import jsPDF from "jspdf";
export default {
    boldText(text, x, y, doc) {
        doc.setFont(undefined, "bold");
        doc.text(x, y, text);
        doc.setFont(undefined, "normal");
      },
      addY(y, by, doc) {
        if (y + by > 275) {
          doc.addPage();
        //   var fontSize = doc.getFontSize();
        //   doc.setFontSize(10);
        //   doc.text(180, 285, "Page " + this.page++);
        //   doc.setFontSize(fontSize);
          return 25;
        } else {
          return y += by;
        }
      },
    generateHtmlforPdf(reviewtype,info,review)
    {
        // let _html=[];
        // _html.push("<html><head>");
        // _html.push("<style>");
        // _html.push("body {");
        // _html.push("margin: 0;");
        // _html.push("font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue','Arial';");
        // _html.push("font-size: 0.7rem;");
        // _html.push("font-weight: 400;");
        // _html.push("line-height: 1.5;");
        // _html.push("color: #212529;");
        // _html.push("text-align: left;");
        // _html.push("background-color: #fff;}");
        // _html.push(".container {margin:5px 30px 30px 30px;}");
        // _html.push(".box {border:1px solid #dcdcdc;margin:10px;}");
        // _html.push(".box-header {border-bottom:1px solid #dcdcdc;padding:0px 20px;}");
        // _html.push(".box-body { padding:20px;}");
        // _html.push(".header { padding:10px; display:inline-block;}");
        // _html.push(".header h1 { padding:0px; margin:0px;font-size:1em;}");
        // _html.push(".header p { padding:0px; margin:0px;font-size:0.8em;}");
        // _html.push(".header div, .header img { display:inline-block;}");
        // _html.push(".header img { float:left;margin-right:20px;}");
        // _html.push(".heading { padding-left:10px; display:block;}");
        // _html.push(".subanswer { padding-left:20px;}");
        // _html.push("</style></head><body><div class=\"container\">");
        // _html.push("<div class=\"header\"><img width=\"30px\" height=\"30px\" src=\"https://managemeds.scot.nhs.uk/img/polypharmacy_Icon.png\" alt=\"Polypharmacy: Managed Medicines\"/>");
        // _html.push("<div><h1>Polypharmacy: Managed Medicines</h1><p><a href=\"https://managemeds.scot.nhs.uk\">https://managingmeds.scot.nhs.uk</a></p></div>");
        // _html.push("</div>");
        // _html.push("<div class=\"heading\">");
        // _html.push("<div><h2>Responses to Questions for My Review</h2></div>");
        // _html.push("</div>");
        // _html.push("<div class=\"box\"><div class=\"box-body\">");
        // _html.push("<div><strong>Name: </strong><span>"+info.name+"</span></div>");
        // _html.push("<div><strong>Date of birth: </strong><span>"+info.dob+"</span></div>");
        // if(info.studyid.length > 0)
        // {
        //     _html.push("<div><strong>Study id: </strong><span>"+info.studyid+"</span></div>");
        // }
        
        // _html.push("<div><strong>Review date: </strong><span>"+info.reviewdate+"</span></div>");
        // _html.push("<div><strong>Date: </strong><span>"+info.date+"</span></div>");
        // _html.push("<div><strong>Review type: </strong><span>"+info.reviewtype+"</span></div>");
        // _html.push("</div></div>");
        
        let reviewquestions = reviewtype ==="prereview"?review.prereview:review.postreview;

        // reviewquestions.forEach(s=>{
               
        //     _html.push("<div class=\"box\"><div class=\"box-header\"><h3>"+s.name+"</h3></div>");
        //     _html.push("<div class=\"box-body\">");
        //     _html.push("<ul>");
        //         s.questions.forEach(q=>{
        //             let _ans = [];
                    
        //             q.prevalues.forEach((v) => {
                        
        //                 if (v.selected) {
        //                     if(v.name.length > 0)
        //                     {
        //                         _ans.push("<p><strong>"+v.name+"</strong></p>");
        //                     }
        //                     if (v.child && v.child.content && v.child.content.length > 0) {
        //                         _ans.push("<div class=\"subanswer\"><p>Freetext response :</p>");
        //                         _ans.push("<div class=\"textarea\"><pre>"+v.child.content+"</pre></div></div>");
        //                     }
        //                 }
        //                 if (v.type === "textarea" && v.content && v.content.length > 0) {
        //                     _ans.push("<p>"+v.name+"</p>");
        //                     _ans.push("<div class=\"textarea\"><pre>"+v.content+"</pre></div>");
        //                 }
        //             });
        //             let _answer =  "";
        //             if(_ans.length > 0){
        //                 _answer = _ans.join(" ");
        //             }
        //             if(_answer.length > 0)
        //             {
        //                 _html.push("<li>");
        //                 _html.push("<p><span>"+q.name+"</span></p>");
        //                 _html.push(_answer);
        //                 _html.push("</li>");
        //             }
                    
        //         });
        //     _html.push("</ul>");
        //     _html.push("</div></div>");
        // });

        // _html.push("</div></body></html>");
        //let html = _html.join("");
        var doc = new jsPDF();
        doc.setFontSize(9);
        var lineheight = 8;
        var x = 20;
        var y = 20;

        var fontSize = doc.getFontSize();
        doc.setFontSize(20);
        doc.setFont(undefined, "bold");
        doc.text("Polypharmacy: Managed Medicines", x, y);
        doc.setFont(undefined, "normal");
        y = this.addY(y, 12, doc);
        doc.setFontSize(18);
        doc.setFont(undefined, "bold");
        doc.text("Questions for my review", x, y);
        doc.setFont(undefined, "normal");
        doc.setFontSize(fontSize);
        y = this.addY(y, lineheight, doc);
        
        doc.text("Name: "+info.name, x, y);
        y = this.addY(y, lineheight, doc);
        doc.text("Date of birth: "+info.dob, x, y);
        y = this.addY(y, lineheight, doc);
        if(info.studyid.length > 0)
        {
            doc.text("Study id: "+info.studyid, x, y);
            y = this.addY(y, lineheight, doc);
        }
        doc.text("Review date: "+info.reviewdate+" Date sent: "+info.date, x, y);
        y = this.addY(y, lineheight, doc);
        doc.text("Review type: "+info.reviewtype, x, y);
        y = this.addY(y, lineheight*1.5, doc);

        reviewquestions.forEach(s=>{
            var fontSize = doc.getFontSize();
            doc.setFontSize(15);
            doc.setFont(undefined, "bold");
            var stitle = doc.splitTextToSize(s.name, 120);
            doc.text(stitle, x, y);
            doc.setFont(undefined, "normal");
            doc.setFontSize(fontSize);
            y = this.addY(y, lineheight*stitle.length, doc);
            s.questions.forEach(q=>{
                doc.setFont(undefined, "bold");
                var qtitle = doc.splitTextToSize(q.name, 120);
                doc.text(qtitle, x, y);
                doc.setFont(undefined, "normal");
                y = this.addY(y, lineheight, doc);
                q.prevalues.forEach((v) => {
                    if (v.selected) {
                        if(v.name.length > 0)
                        {
                            doc.text(v.name, x, y);
                            y = this.addY(y, lineheight, doc);
                            if (v.child && v.child.content && v.child.content.length > 0) {
                                doc.text("Freetext response: "+v.child.content, x, y, { maxWidth: 120 });
                                y = this.addY(y, lineheight, doc);
                            }
                            if (v.type === "textarea" && v.content && v.content.length > 0) {
                                doc.text(v.name+": "+v.content, x, y, { maxWidth: 120 });
                                y = this.addY(y, lineheight, doc);
                            }
                        }
                    }
                });
            });
        });

        return doc;
    }
}